import { Language } from "../languages/labels/language.labels";

export function statusConsignmentList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'active', display: lang.labels.active },
    { code: 'closed', display: lang.labels.closed }
  ]
}

export function statusConsignmentValue(lang: Language, code: string): string {
  let status = statusConsignmentList(lang).find((item) => (item.code === code))
  return status ? status.display : lang.labels.undefined
}
